// Keys for the drawer drilldown registry in `blocks.ts`, extracted into their own module.
//
// Why: chart blocks (e.g. BarchartBlock, DoubleBarChartBlock) need
// `TRANSCATION_HISTORY_ACTION_BLOCK` to tag a chart bar's drilldown context, but they are
// themselves re-exported through `../blocks` -> `mappings/blocks.ts` imports from that same
// barrel to build its `blocks` registry. Importing the key straight from `mappings/blocks.ts`
// closed that loop into a circular import: evaluating `mappings/blocks.ts` pulled in the
// `blocks` barrel, which (before it got to `ComponentBlocks`/`AccountBlock`) loaded
// `BarchartBlock`, which imported back into the still-initializing `mappings/blocks.ts` —
// tripping a "Cannot access 'AccountBlock' before initialization" TDZ error in Storybook/Vite.
//
// Keeping the keys here (no dependency on `mappings/blocks.ts`) lets chart blocks reference
// them without re-entering that module.
export const actionBlocksKey = {
  PLACEHOLDER_ACTION_BLOCK: 'PlaceholderActionBlock',
  MAKE_TRANSFER_ACTION_BLOCK: 'make_transfer',
  TRANSCATION_HISTORY_ACTION_BLOCK: 'transaction_history_block',
  TRANSACTION_DETAILS_ACTION_BLOCK: 'transaction_details',
}
